"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListRow = void 0;
var React = require("react");
var components_1 = require("components");
var ListRow = function (props) {
    var findProject = function (selected) {
        return selected.vektorioId == props.item.vektorioId;
    };
    var selected = props.selected.find(findProject);
    var select = selected ? props.deselect : props.select;
    var onClick = function () { return select(props.item); };
    return (React.createElement("div", { className: "list-row-vektorio-projects" },
        React.createElement(components_1.TableRowIcon, { icon: 'fa-check', className: selected ? 'selected' : '', circle: true, onClick: onClick }),
        React.createElement("div", null, props.item.name)));
};
exports.ListRow = ListRow;
